export default __webpack_public_path__ + "static/media/internal-server-error.dd3e0eff.svg";